import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import { filterNames } from '@/billing/pages/BillingPage/constants'
import { ActionsContainer } from '@/billing/pages/BillingPage/styles'
import DateRangeFilter from '@/common/components/DateRangeFilter/DateRangeFilter'

import { filterTypes } from '../FilterTypeSelector/constants'
import FilterTypeSelector from '../FilterTypeSelector/FilterTypeSelector'
import StatusSelector from '../StatusSelector/StatusSelector'
import { FiltersModalContainer } from '../styles'
import TypeSelector from '../TypeSelector/TypeSelector'

const FiltersModal = ({ show, onClose, filters, onChangeFilter, onApplyFilters, preselectedFilterType }) => {
  const { t } = useTranslation()
  const [filterType, setFilterType] = useState(preselectedFilterType || filterTypes[0].value)
  const [typeSelected, setTypeSelected] = useState(filters?.billingType)
  const [statusSelected, setStatusSelected] = useState(filters?.billingStatus)
  const [invoiceDatesSelected, setInvoiceDatesSelected] = useState(filters?.invoiceDates)
  const [collectedDatesSelected, setCollectedDatesSelected] = useState(filters?.collectedDates)

  useEffect(() => {
    if (show) {
      setFilterType(preselectedFilterType || filterTypes[0].value)
      setTypeSelected(filters?.billingType)
      setStatusSelected(filters?.billingStatus)
      setInvoiceDatesSelected(filters?.invoiceDates)
      setCollectedDatesSelected(filters?.collectedDates)
    }
  }, [filters, preselectedFilterType, show])

  const applyFilters = () => {
    if (filterType === filterNames.type) {
      onChangeFilter(filterNames.type, typeSelected, false)
    }

    if (filterType === filterNames.status) {
      onChangeFilter(filterNames.status, statusSelected, false)
    }

    if (filterType === filterNames.invoiceDates) {
      if (invoiceDatesSelected?.startDate) {
        onChangeFilter(filterNames.invoiceDateStart, invoiceDatesSelected?.startDate, false)
      }

      if (invoiceDatesSelected?.endDate) {
        onChangeFilter(filterNames.invoiceDateEnd, invoiceDatesSelected?.endDate, false)
      }
    }

    if (filterType === filterNames.collectedDates) {
      if (collectedDatesSelected?.startDate) {
        onChangeFilter(filterNames.collectedDateStart, collectedDatesSelected?.startDate, false)
      }

      if (collectedDatesSelected?.endDate) {
        onChangeFilter(filterNames.collectedDateEnd, collectedDatesSelected?.endDate, false)
      }
    }

    onClose()
    onApplyFilters()
  }

  return (
    <Modal
      title={preselectedFilterType ? t('Editar filtro') : t('Añadir filtro')}
      show={show}
      onClose={onClose}
      size="l"
      actions={
        <ActionsContainer>
          <Button onClick={onClose} bordered>
            {t('Cancelar')}
          </Button>
          <Button onClick={applyFilters}>{preselectedFilterType ? t('Editar filtro') : t('Añadir filtro')}</Button>
        </ActionsContainer>
      }
    >
      <FiltersModalContainer>
        <FilterTypeSelector
          value={filterType}
          onChange={value => setFilterType(value)}
          disabled={preselectedFilterType}
        />
        {filterType === filterNames.status && (
          <StatusSelector value={statusSelected} onChange={value => setStatusSelected(value)} />
        )}
        {filterType === filterNames.type && (
          <TypeSelector value={typeSelected} onChange={value => setTypeSelected(value)} />
        )}
        {filterType === filterNames.invoiceDates && (
          <DateRangeFilter
            value={{ rangeValue: invoiceDatesSelected }}
            onChangeRange={value => setInvoiceDatesSelected(value)}
          />
        )}
        {filterType === filterNames.collectedDates && (
          <DateRangeFilter
            value={{ rangeValue: collectedDatesSelected }}
            onChangeRange={value => setCollectedDatesSelected(value)}
          />
        )}
      </FiltersModalContainer>
    </Modal>
  )
}

export default FiltersModal
